import {
	$$,
	IComponentBindings,
	ComponentOptions,
	IClearBreadcrumbEventArgs,
	InitializationEvents,
	IPopulateBreadcrumbEventArgs,
	BreadcrumbEvents,
	IBreadcrumbItem,
	Initialization,
	QueryEvents
} from 'coveo-search-ui';

import { AtlasComponent } from "./../models/AtlasComponent";

export class SelectedFilters extends AtlasComponent {
	static ID = 'SelectedFilters';

	private lastBreadcrumbs: IBreadcrumbItem[];

	constructor(public element: HTMLElement, options: ComponentOptions, bindings?: IComponentBindings) {
		super(element, SelectedFilters.ID, bindings);
		this.options = ComponentOptions.initComponentOptions(element, SelectedFilters, options);

		this.bind.onRootElement(QueryEvents.querySuccess, () => this.render());
		this.bind.onRootElement(QueryEvents.deferredQuerySuccess, () => this.render());
	}

	public getBreadcrumbs(): IBreadcrumbItem[] {
		const args = <IPopulateBreadcrumbEventArgs>{ breadcrumbs: [] };
		this.bind.trigger(this.root, BreadcrumbEvents.populateBreadcrumb, args);
		// this.logger.debug('Retrieved breadcrumbs', args.breadcrumbs);
		this.lastBreadcrumbs = args.breadcrumbs;
		return args.breadcrumbs;
	}

	public clearBreadcrumbs() {
		const args = <IClearBreadcrumbEventArgs>{};
		this.bind.trigger(this.root, BreadcrumbEvents.clearBreadcrumb, args);
		this.queryController.executeQuery();
	}

	public render(breadcrumbs?: IBreadcrumbItem[]) {
		var crumbs = breadcrumbs || this.getBreadcrumbs() || [];
		this.empty();
		if (!crumbs.length) {
			this.hide();
			return;
		}

		this.show();
		crumbs.forEach((crumb) => this.element.appendChild(crumb.element));
	}

	public refresh() {
		this.render(this.lastBreadcrumbs);
	}
}

Initialization.registerAutoCreateComponent(SelectedFilters);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SelectedFilters.ts